export const interiorA01ImageOptions = {
  angle: 'InteriorA01',
  staticOptions: {
    UpholsteryCabin: 1,
    Blinds: 1
  },
  mattes: [
    {
      option: 'UpholsteryCabin',
      dependency: null
    }
  ]
}



// WEBPACK FOOTER //
// ./src/Xpower/views/InteriorA01.js